import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Sirve para todas las edades?',
    a: 'Sí. El Método está organizado por franjas de edad (4-6, 7-9 y 10-12 años) para que cada actividad sea apropiada y efectiva para el nivel de desarrollo de tu hijo.'
  }, {
    q: '¿Cómo recibo el material?',
    a: 'Al instante. En menos de 5 minutos recibís un email con acceso directo a todos los tomos y bonos en PDF listos para leer o imprimir.'
  }, {
    q: '¿Qué lo diferencia de lo que encuentro gratis en internet?',
    a: 'Las actividades gratuitas son genéricas, sin secuencia y sin sistema. El Método Mente Enfocada tiene una progresión diseñada para reconectar la atención de tu hijo paso a paso, con neurociencia aplicada y resultados medibles.'
  }, {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días completos. Si no ves resultados reales, te devolvemos el 100%. Sin letra chica.'
  }, {
    q: '¿Necesito materiales especiales?',
    a: 'No. Todo con materiales que ya tenés en casa o conseguís en cualquier kiosco o supermercado.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-dark-800 py-12 px-4" data-id="element-86">
      <div className="max-w-3xl mx-auto" data-id="element-87">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-cream" data-id="element-88">
          ❓ LO QUE MÁS NOS PREGUNTAN
        </h2>

        <div className="space-y-3" data-id="element-89">
          {faqs.map((faq, i) => <div key={i} className="bg-dark-900 border border-primary/30 rounded-2xl overflow-hidden" data-id="element-90">
              <button onClick={() => setOpenIndex(openIndex === i ? null : i)} className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-91">
                <span className="font-bold text-cream text-base md:text-lg pr-4" data-id="element-92">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 md:w-6 md:h-6 text-primary transition-transform duration-300 flex-shrink-0 ${openIndex === i ? 'rotate-180' : ''}`} data-id="element-93" />
              </button>
              <AnimatePresence data-id="element-94">
                {openIndex === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-95">
                    <div className="px-5 pb-4 text-cream/80 border-t border-primary/20 pt-3 text-sm md:text-base" data-id="element-96">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}